module.exports = __webpack_public_path__ + "static/bg_wheel-f92f12113fd2936d4e60dbca8fd10788.png";